export const annualSalesOptions = [
  { label: "Menos de $500K", value: "<500K" },
  { label: "$500K - $1M", value: "<1M" },
  { label: "$1 - $4M", value: "<4M" },
  { label: "$4 - 25M", value: "<25M" },
  { label: "$25 -$100M", value: "<100M" },
  { label: "$100 - $250M", value: "<250M" },
  { label: "Más de $250M", value: ">250M" }
];
